/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drag_And_Drop_IntelligenceInputs */

const en_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag & Drop Intelligence`)
};

const es_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia de arrastrar y soltar`)
};

const fr_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence par glisser-déposer`)
};

const de_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag & Drop Intelligenz`)
};

const ja_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドラッグ＆ドロップインテリジェンス`)
};

const zh_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖拽式智能解析`)
};

const ar_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذكاء السحب والإفلات`)
};

const id_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan Drag & Drop`)
};

const it_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligenza Drag & Drop`)
};

const ru_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеллектуальное распознавание (Drag & Drop)`)
};

const pt_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligência Arrastar e Soltar`)
};

const ko_drag_and_drop_intelligence = /** @type {(inputs: Drag_And_Drop_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드래그 앤 드롭 인텔리전스`)
};

/**
* | output |
* | --- |
* | "Drag & Drop Intelligence" |
*
* @param {Drag_And_Drop_IntelligenceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const drag_and_drop_intelligence = /** @type {((inputs?: Drag_And_Drop_IntelligenceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drag_And_Drop_IntelligenceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drag_and_drop_intelligence(inputs)
	if (locale === "es") return es_drag_and_drop_intelligence(inputs)
	if (locale === "fr") return fr_drag_and_drop_intelligence(inputs)
	if (locale === "de") return de_drag_and_drop_intelligence(inputs)
	if (locale === "ja") return ja_drag_and_drop_intelligence(inputs)
	if (locale === "zh") return zh_drag_and_drop_intelligence(inputs)
	if (locale === "ar") return ar_drag_and_drop_intelligence(inputs)
	if (locale === "id") return id_drag_and_drop_intelligence(inputs)
	if (locale === "it") return it_drag_and_drop_intelligence(inputs)
	if (locale === "ru") return ru_drag_and_drop_intelligence(inputs)
	if (locale === "pt") return pt_drag_and_drop_intelligence(inputs)
	return ko_drag_and_drop_intelligence(inputs)
});